import usePermission from '../hooks/usePermission';
import NoPermissionPage from '../components/common/NoPermissionPage';
import LoadingSpinner from '../components/common/LoadingSpinner/LoadingSpinner';

export default function PermissionRoute({ perm, children }) {
  const { has, meLoading } = usePermission();
  if (meLoading)
    return (
      <div className="py-5 d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
        <LoadingSpinner />
      </div>
    );
  if (!has(perm)) return <NoPermissionPage />;

  return children;
}
